<template>
<v-card class='mt-3 pt-1 mx-auto' v-resize='onResize'>
  <v-sheet class='v-sheet--offset mx-auto pa-0' :color='color' elevation='10' max-width='calc(100% - 32px)' height='240'>
    <div :ref='ref' class='pt-3' style='width: 98%; height: 220px;' :style='setStyle' />
  </v-sheet>

  <v-card-text class='pt-0'>
    <div class='title font-weight-light mb-2'><b>{{ title }}</b></div>
    <div class='subheading font-weight-light grey--text'>{{ desc }}</div>
    <v-divider class='my-2' />
    <v-icon class='mr-2' small>mdi-clock</v-icon>
    <!-- <span class='caption grey--text font-weight-light'>last update {{ random(20) }} minutes ago</span> -->
  </v-card-text>
</v-card>
</template>


<script>
import color from '@/components/plugins/color'

export default {
  props: ['title', 'desc', 'color'],
  data: () => ({
    chart: null,
    option: null,
    labels: ['Sun','Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  }),
  computed: {
    ref() {
      return `echartsCard${ this.title }`
    },
    setStyle() {
      return {
        background: this.color
      }
    },
    weeklyBuildingLoad(){
      return this.$store.state.skyspark.weeklyBuildingLoad;
    },
    weeklyNetPower(){
      return this.$store.state.skyspark.weeklyNetPower;
    }
  },
  methods: {
    // valueAcu() {
    //   const arr = [...this.energyUse]
    //   this.energyUse.forEach((item,index) => (arr[index] = index > 0 ? arr[index-1]+item : ''))
    //   console.log(arr)
    //   return arr
    // },
    drawChart(refresh) {
      this.chart.setOption(this.option, refresh)
      this.onResize()
    },
    onResize() {
      if(this.chart) _.debounce(this.chart.resize, 100)()
    },
    refreshChart() {
      this.option = {
        color,
        tooltip: {
          trigger: 'axis'
        },
        textStyle: {
          color: 'white',
          fontSize: 8
        },
        grid: {
          // containLabel: true,
          top: 5,
          left: 10,
          right: 10,
          bottom: 20,
          // width: '100%',
          // height: '100%',
        },
        legend: {
          left: 'right',
          orient: 'vertical',
          textStyle: {
            fontSize: 16,
          }
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          data: this.labels,
        }],
        yAxis: [{
          show: false,
          type: 'value',
          name: 'line',
          min: 0,
          //max: 600,
        }, {
          show: false,
          type: 'value',
          name: 'line',
          min: 0,
          //max: 3600,
        }],
        series: [{
          name: 'Building Load (kWh)',
          type: 'line',
          lineStyle: {
            width: 3,
            color: 'purple',
            shadowColor: 'rgba(0,0,0,0.7)',
            shadowBlur: 10,
          },
          itemStyle: {
            color: 'purple',
          },
          smooth: false,
          data: this.weeklyBuildingLoad
        }, {
          name: 'Returned to Grid (kWh)',
          type: 'bar',
          yAxisIndex: 1,
          itemStyle: {
            color: 'rgba(255, 255, 255, 0.55)',
            borderRadius: [3, 3, 0, 0]
          },
          data: this.weeklyNetPower
        }]
      }
    }
    // random(x) {
    //   return _.random(5, x)
    // }
  },
  watch: {
    weeklyBuildingLoad: function(newData,oldData){
      this.refreshChart()
      this.drawChart();
    },
    weeklyNetPower: function(newData,oldData){
      this.refreshChart()
      this.drawChart();
    }
  },
  mounted() {
    // console.log(this.weeklyBuildingLoad)
    this.chart = echarts.init(this.$refs[this.ref])
    this.refreshChart();
    this.drawChart()
  },
  beforeDestroy() {
    echarts.dispose(this.chart)
  }
}
</script>

<style lang='stylus'>
.v-sheet--offset
  top: -24px
  position: relative
</style>
